import { defineMessages } from 'react-intl';

export default defineMessages({
    tcTitle: {
        id: 'tdic.tnc.details.title',
        defaultMessage: 'Terms & Conditions'
    },
    tcIframeTitle: {
        id: 'tdic.tnc.details.iframe.title',
        defaultMessage: 'Portal Terms & Conditions'
    },
    tcIframeContent: {
        id: 'tdic.tnc.details.iframe.content',
        defaultMessage: 'Content'
    },
    tcIframeCkboxText: {
        id: 'tdic.tnc.details.ckbox.text',
        defaultMessage: 'I Agree'
    },
    tcIframeSubmitText: {
        id: 'tdic.tnc.details.submit.text',
        defaultMessage: 'Accept'
    },
    tcLink: {
        id: 'tdic.tnc.details.link',
        defaultMessage: 'Terms of Use'
    }
});
